import { IAppender, ServerLogger } from 'core/infrastructure';
import Electron from './Electron';
import * as Cordova from './Cordova';
import { Settings } from './Settings';

export function create(settings: Settings): IAppender {

	const appender: IAppender = {
		append: (date, level, message) => {

			if (Electron.isEnabled()) {
				void Electron.Log.write(level, message);
				return;
			}

			if (Cordova.isCordovaNavigator() && Cordova.isInitialized()) {
				void Cordova.writeToLog(level, message);
				return;
			}

			ServerLogger.sendToServer(settings.posId.toString(), date, level, message);
		}
	};

	return appender;
}
